// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"gr-z","imageAndVideoCount":"hr-z","imageAndVideoContainer":"ir-z","viewAllReviews":"jr-z"};